export const opening = [
  'Os CRIs emitidos somaram mais de R$50,00 bilhões pelo quarto ano seguido. Os CRAs bateram recorde: R$45,85 bilhões. Os CRs cresceram a um CAGR de quase 71% desde 2022. Os estoques somados de CRI e CRA passaram de R$400 bilhões. Os números são bons. Mas em 2025, pelo menos dois episódios lembraram que números bons e mercado saudável não são a mesma coisa.',
  'Uma reclamação formal entregue à CVM acusou a Virgo (atual Riza), uma das três maiores securitizadoras do país, de alocar recursos de fundos de reserva de CRIs e CRAs em veículos usados para honrar garantia firme de distribuição. A cifra sob disputa: R$240 milhões movimentados entre contas de clientes, com trocas de mensagens por WhatsApp anexadas como evidência. No caso da Habitasec/Cartesia, as denúncias apontaram omissão de fatos relevantes e inclusão de imóveis quitados como lastro de garantias. As partes negam irregularidades e há litígios em curso. O dano reputacional, porém, já está feito.',
  'O que chama a atenção da Uqbar nesses episódios não é o comportamento das securitizadoras em si, sobre o qual a CVM deve manifestar. É o silêncio em torno dos agentes fiduciários. Todas as operações de CRI citadas nas denúncias instituíam regime fiduciário. O agente fiduciário existe para monitorar a securitizadora e proteger o investidor. Se houve movimentações em desacordo com o termo de securitização e o agente não detectou, a falha é dele também, por omissão ou por falta de estrutura. Os dados deste anuário mostram que três agentes fiduciários concentram mais de 94% do estoque de CRI e quase 100% do de CRA. Concentração assim só se justifica se vier acompanhada de capacidade proporcional de fiscalização. Os episódios recentes sugerem que essa capacidade é, no mínimo, questionável.',
  'Outro ponto incômodo: decisões sobre a destinação de recursos de operações estruturadas eram tomadas e comunicadas via WhatsApp. Se uma das maiores securitizadoras operava assim, o que se passa nas outras? A ABSIA, associação da qual tanto Virgo quanto Habitasec são integrantes, publicou há pouco mais de um ano um manual de boas práticas que formalizou rotinas já adotadas pela maioria das associadas. Falta cobrar mais. Falta definir requisitos mínimos que sejam verificáveis, não apenas declaratórios.',
  'E há a transparência, o problema mais antigo e mais persistente. A Uqbar acompanha o mercado de CRI desde o início e o nível de divulgação, embora tenha evoluído, partiu de uma base tão pequena que o patamar atual ainda é insuficiente. A maior parte das securitizadoras não consegue manter sequer a coesão de um informe mensal. No segmento de crowdfunding, onde os CRs crescem com mais velocidade, a situação é pior: plataformas exigem cadastro e questionários antes de mostrar qualquer detalhe das ofertas, escondem o histórico de operações encerradas e restringem a análise a telas de celular. Quando a vitrine é opaca, o investidor não está tomando risco de crédito plenamente consciente.',
  'É tentador pedir à CVM que resolva tudo com mais fiscalização. Mas a autarquia não tem como examinar centenas de operações por ano com a profundidade necessária, nem deveria ser a única linha de defesa. O agente fiduciário já é um mecanismo de controle. Coordenadores e investidores institucionais têm obrigação contratual de fazer due diligence. A Consulta Pública SDM nº 05/25, que propõe a reforma da RCVM 88, abre uma janela para eliminar barreiras de acesso à informação e exigir dados padronizados e auditáveis. A norma ajuda, mas não basta. O mercado precisa transformar princípios em controles: decisões por canais formais, revisão documental efetiva e fiscalização privada exigente.',
  'CRIs, CRAs e CRs são títulos que chegam ao varejo. Se investidores profissionais deixaram passar as lacunas de governança que vieram à tona em 2025, o que se pode esperar da pessoa física que investe com base em uma lâmina resumida e uma taxa atrativa?',
  'Este anuário registra o crescimento do mercado com a precisão que os dados exigem. Registra também que crescer não é amadurecer.',
];

export const primaryMarket = {
  intro: [
    'O mercado primário de securitização movimentou mais de R$100 bilhões em 2025, somando CRIs, CRAs e CRs. Os CRIs recuaram 21% em volume frente a 2024, pressionados pelas restrições das Resoluções CMN nº 5.118 e nº 5.121. Os CRAs, por outro lado, bateram recorde, com R$45,85 bilhões. Os CRs mantiveram a trajetória de crescimento acelerado, com CAGR de quase 71% desde 2022, impulsionados pelo crowdfunding e pelo rito automático da RCVM 160.',
    'O ano foi marcado por duas tendências opostas. De um lado, o aumento da taxa Selic elevou a participação do CDI como indexador tanto em CRIs quanto em CRAs, deslocando o IPCA. De outro, o aperto regulatório sobre os lastros de CRI forçou uma correção de rota que já se reflete nos números: operações genuinamente imobiliárias passaram a dominar ainda mais a composição das emissões.',
  ],
  charts: [
    {
      title: 'Emissões de CR',
      link: 'https://metabase.uqbaronline.com/question/824-cr-montante-emitido-e-numero-de-operacoes',
      description:
        'O mercado de CRs saiu de 3 emissões e R$903,06 milhões em 2022 para 398 operações e R$4,51 bilhões em 2025, com aceleração relevante a partir de 2024.',
      data: [
        { ano: '2022', montante_emitido: 903059000, numero_operacoes: 3 },
        {
          ano: '2023',
          montante_emitido: 170993922.51999992,
          numero_operacoes: 9,
        },
        {
          ano: '2024',
          montante_emitido: 4221302217.219865,
          numero_operacoes: 261,
        },
        {
          ano: '2025',
          montante_emitido: 4514024306.0718,
          numero_operacoes: 398,
        },
      ],
    },
    {
      title: 'Emissões de CR por Tipo de Lastro',
      link: 'https://metabase.uqbaronline.com/question/826-cr-emissao-por-lastro',
      description:
        'Aquisição de ativos liderou em 2025, seguida por pagamento de despesas e comercialização de insumos agrícolas, com maior granularidade de lastros no ano.',
      data: [
        { categoria: 'Aquisição de ativos', valor: 2367508253.1595 },
        { categoria: 'Pagamento de despesas', valor: 877451536.88 },
        {
          categoria: 'Comercialização de insumos agrícolas',
          valor: 560000000,
        },
        { categoria: 'Não informado', valor: 399102321.419 },
        { categoria: 'Financiamento', valor: 138240551.49330002 },
        { categoria: 'Reforço de caixa', valor: 85000000 },
        { categoria: 'Reforço de capital de giro', valor: 62845393.17 },
        { categoria: 'Recebíveis comerciais', valor: 16738400 },
        { categoria: 'Crédito pessoal', valor: 4037849.9499999997 },
        { categoria: 'Aluguel', valor: 3100000 },
      ],
    },
    {
      title: 'Emissões de CR por Tipo de Devedor',
      link: 'https://metabase.uqbaronline.com/question/830-cr-emissao-por-tipo-devedor',
      description:
        'Pessoas jurídicas lideraram as emissões de CR em 2025, seguidas por operações multidevedor e pessoas físicas.',
      data: [
        { categoria: 'Pessoa jurídica', valor: 2787141563.4895 },
        { categoria: 'Multidevedor', valor: 1122359211.8322997 },
        { categoria: 'Pessoa física', valor: 560524598.2 },
        { categoria: 'Não informado', valor: 43998932.55 },
      ],
    },
    {
      title: 'Emissões de CRI',
      link: 'https://metabase.uqbaronline.com/question/734-emissoes-de-cri',
      description:
        'As emissões de CRI alcançaram R$50,01 bilhões em 2025, em 445 operações, mantendo o patamar acima de R$50 bilhões pelo quarto ano consecutivo.',
      data: [
        {
          ano: '2024',
          montante_emitido: 63287390744.89998,
          numero_operacoes: 562,
        },
        {
          ano: '2025',
          montante_emitido: 50020210436.87,
          numero_operacoes: 445,
        },
      ],
    },
    {
      title: 'Emissões de CRI por Tipo de Risco de Crédito',
      link: 'https://metabase.uqbaronline.com/question/96-emissoes-de-cri-por-tipo-de-risco-de-credito',
      description:
        'Os CRIs de risco concentrado responderam por 82,54% do total em 2025, com risco pulverizado em 17,46%.',
      data: [
        { categoria: 'Risco concentrado', valor: 41351493025.880005 },
        { categoria: 'Risco pulverizado', valor: 8668717410.99 },
      ],
    },
    {
      title: 'Emissões de CRI por Tipo de Devedor',
      link: 'https://metabase.uqbaronline.com/question/95-emissoes-de-cri-por-tipo-de-devedor',
      description:
        'Pessoas jurídicas dominaram as emissões de CRI em 2025, respondendo pela maior parte do volume, seguidas por pessoas físicas e multidevedores.',
      data: [
        { categoria: 'Pessoa jurídica', valor: 51422618073.1099 },
        { categoria: 'Pessoa física', valor: 7701405844.79 },
        { categoria: 'Multidevedor', valor: 4163366827 },
      ],
    },
    {
      title: 'Emissões de CRI por Tipo de Remuneração',
      link: 'https://metabase.uqbaronline.com/question/99-emissoes-de-cri-por-tipo-de-remuneracao',
      description:
        'O CDI liderou as remunerações de CRI em 2025 com R$27,91 bilhões, seguido por IPCA (R$16,54 bilhões) e taxa fixa (R$5,25 bilhões).',
      data: [
        { categoria: 'CDI', valor: 27908811067.39 },
        { categoria: 'IPCA', valor: 16542329258.479996 },
        { categoria: 'Taxa Fixa', valor: 5248126000 },
        { categoria: 'INCC-DI', valor: 225600000 },
        { categoria: 'IGP-M', valor: 95344111 },
      ],
    },
    {
      title: 'Emissões de CRI por Faixa de Prazo',
      link: 'https://metabase.uqbaronline.com/question/120-emissoes-de-cri-por-faixa-de-prazo',
      description:
        'As emissões de CRI entre 2 e 5 anos concentraram R$20,74 bilhões em 2025, seguidas pela faixa de 5 a 10 anos (R$19,95 bilhões).',
      data: [
        { categoria: 'de 2 a 5 anos', valor: 20737551500 },
        { categoria: 'de 5 a 10 anos', valor: 19948140468.91 },
        { categoria: 'acima de 10 anos', valor: 8613926467.960003 },
        { categoria: 'até 2 anos', valor: 720592000 },
      ],
    },
    {
      title: 'Número de Operações de CRI por Ativo Lastro',
      link: 'https://metabase.uqbaronline.com/question/304-numero-de-operacoes-de-cri-por-ativo-lastro',
      description:
        'Crédito imobiliário liderou com 391 operações em 2025 (88,08%), seguido por aluguel (34) e crédito pessoal (12).',
      data: [
        { categoria: 'Crédito Imobiliário', valor: 391 },
        { categoria: 'Aluguel', valor: 34 },
        { categoria: 'Crédito Pessoal', valor: 12 },
        { categoria: 'Multiclasse', valor: 2 },
        { categoria: 'Outros', valor: 6 },
      ],
    },
    {
      title: 'Emissões de CRI por Segmento Imobiliário',
      link: 'https://metabase.uqbaronline.com/question/100-emissoes-de-cri-por-segmento-imobiliario',
      description:
        'Apartamentos e Casas lideraram com R$26,18 bilhões em 2025, seguidos por Varejo (R$6,16 bilhões) e Logístico e Industrial (R$5,99 bilhões).',
      data: [
        { categoria: 'Apartamentos e Casas', valor: 26176482391.379997 },
        { categoria: 'Varejo - Shoppings, Lojas etc', valor: 6163899102 },
        { categoria: 'Logístico e Industrial', valor: 5992638057.47 },
        { categoria: 'Loteamento', valor: 3465551399 },
        { categoria: 'Lajes Corporativas', valor: 3896229487.02 },
        { categoria: 'Infraestrutura', valor: 1961775000 },
        { categoria: 'Hotelaria', valor: 977756000 },
        { categoria: 'Clínicas e Hospitais', valor: 860000000 },
        { categoria: 'Multisegmento', valor: 282112000 },
        { categoria: 'Demais segmentos', valor: 243937000 },
      ],
    },
    {
      title: 'Perfil dos investidores de CRIs em 2025',
      link: 'https://metabase.uqbaronline.com/question/735-perfil-de-investidores-de-cri',
      description:
        'Fundos de investimento lideraram as subscrições de CRI em 2025 com R$10,58 bilhões, seguidos por pessoas físicas (R$9,91 bilhões) e instituições ligadas à emissora (R$5,78 bilhões).',
      data: [
        { categoria: 'Fundos de investimento', valor: 10588570066.335 },
        { categoria: 'Pessoas Físicas', valor: 9918284704.060001 },
        {
          categoria: 'Instituições financeiras ligadas à emissora',
          valor: 5785513882.5,
        },
        {
          categoria: 'Instituições Intermediárias do consórcio',
          valor: 2102047000,
        },
        { categoria: 'Demais instituições financeiras', valor: 411584815 },
        { categoria: 'Demais pessoas jurídicas', valor: 373308668.46 },
        { categoria: 'Investidores estrangeiros', valor: 81319000 },
        { categoria: 'Demais', valor: 43371118.01 },
      ],
    },
    {
      title: 'Emissões de CRA',
      link: 'https://metabase.uqbaronline.com/question/705-emissoes-de-cra-2024',
      description:
        'As emissões de CRA bateram novo recorde em 2025, com R$45,79 bilhões em 146 operações.',
      data: [
        {
          ano: '2024',
          montante_emitido: 41783694852,
          numero_operacoes: 186,
        },
        {
          ano: '2025',
          montante_emitido: 45786556407.3,
          numero_operacoes: 146,
        },
      ],
    },
    {
      title: 'Emissões de CRA por Tipo de Risco de Crédito',
      link: 'https://metabase.uqbaronline.com/question/703-emissoes-de-cra-por-tipo-de-risco-de-credito-2024',
      description:
        'Em 2025, o risco concentrado respondeu por 97,15% das emissões de CRA, com R$44,48 bilhões, e o risco pulverizado por R$1,31 bilhão.',
      data: [
        { categoria: 'Risco concentrado', valor: 44481110460.3 },
        { categoria: 'Risco pulverizado', valor: 1305445947 },
      ],
    },
    {
      title: 'Emissões de CRA por Tipo de Devedor',
      link: 'https://metabase.uqbaronline.com/question/710-emissoes-de-cra-por-tipo-de-devedor-2024',
      description:
        'Pessoas jurídicas concentraram 98,70% das emissões de CRA em 2025, com R$45,19 bilhões.',
      data: [
        { categoria: 'Pessoa Jurídica', valor: 45192644407.3 },
        { categoria: 'Pessoa Física', valor: 498912000 },
        { categoria: 'Multidevedor', valor: 95000000 },
      ],
    },
    {
      title: 'Emissões de CRA por Tipo de Contrato Lastro',
      link: 'https://metabase.uqbaronline.com/question/698-emissoes-de-cra-por-tipo-de-contrato-lastro-2024',
      description:
        'CPRs Financeiras lideraram os lastros de CRA em 2025 com R$21,49 bilhões, seguidas por debêntures com R$16,41 bilhões e notas comerciais com R$4,44 bilhões.',
      data: [
        { categoria: 'CPR Financeira', valor: 21492205407.3 },
        { categoria: 'Debêntures', valor: 16412304000 },
        { categoria: 'Nota Comercial', valor: 4436836000 },
        { categoria: 'CDCA', valor: 2071395000 },
        { categoria: 'CCI (Notas Comerciais)', valor: 950000000 },
        { categoria: 'Outros', valor: 423816000 },
      ],
    },
    {
      title: 'Emissões de CRA por Tipo de Remuneração',
      link: 'https://metabase.uqbaronline.com/question/712-emissoes-de-cra-por-tipo-de-remuneracao',
      description:
        'O CDI foi o principal indexador de CRA em 2025, com R$23,31 bilhões (50,91%), seguido por taxa fixa com R$11,39 bilhões (24,88%) e IPCA com R$10,77 bilhões (23,52%).',
      data: [
        { categoria: 'CDI', valor: 23309783000 },
        { categoria: 'Taxa Fixa', valor: 11391991000 },
        { categoria: 'IPCA', valor: 10773064524.3 },
        { categoria: 'PTAX800', valor: 211717883 },
        { categoria: 'Não informado', valor: 100000000 },
      ],
    },
    {
      title: 'Emissões de CRA por Segmento',
      link: 'https://metabase.uqbaronline.com/question/701-emissoes-de-cra-por-segmento-2024',
      description:
        'Atividades pecuárias lideraram as emissões de CRA em 2025 com R$14,24 bilhões, seguidas por grãos (R$9,42 bilhões) e sucroenergético (R$5,65 bilhões).',
      data: [
        { categoria: 'Atividades Pecuárias', valor: 14244721000 },
        { categoria: 'Grãos', valor: 9422735000 },
        { categoria: 'Sucroenergético', valor: 5648821524.3 },
        { categoria: 'Diversos', valor: 4353652000 },
        { categoria: 'Não informado', valor: 4521122000 },
        { categoria: 'Insumos Agrícolas', valor: 2585504883 },
        { categoria: 'Fibras', valor: 3180000000 },
        { categoria: 'Frutas e Legumes', valor: 680000000 },
        { categoria: 'Serviços Logísticos', valor: 1000000000 },
        { categoria: 'Máquinas Agrícolas e Equipamentos', valor: 150000000 },
      ],
    },
    {
      title: 'Perfil de Investidores de CRA em 2025',
      link: 'https://metabase.uqbaronline.com/question/708-perfil-de-investidores-de-cra-2024',
      description:
        'Pessoas físicas lideraram as subscrições de CRA em 2025, com R$19,71 bilhões (49,62% do total de R$39,73 bilhões), seguidas por instituições financeiras ligadas à emissora (R$9,37 bilhões).',
      data: [
        { categoria: 'Pessoas Físicas', valor: 19712294428 },
        {
          categoria: 'Instituições financeiras ligadas à emissora',
          valor: 9373230218,
        },
        {
          categoria: 'Instituições Intermediárias do consórcio',
          valor: 5351050000,
        },
        { categoria: 'Fundos de investimento', valor: 3731954840 },
        {
          categoria: 'Sócios e pessoas ligadas à emissora',
          valor: 579054000,
        },
        { categoria: 'Clubes de investimento', valor: 295129000 },
        { categoria: 'Demais pessoas jurídicas', valor: 281025900 },
        { categoria: 'Demais instituições financeiras', valor: 230098000 },
        { categoria: 'Investidores estrangeiros', valor: 96238000 },
        { categoria: 'Outros', valor: 78732000 },
      ],
    },
    {
      title: 'Emissões de CRA por Faixa de Prazo',
      link: 'https://metabase.uqbaronline.com/question/714-cra-faixa-de-prazo-2024',
      description:
        'A faixa de 5 a 10 anos concentrou R$23,05 bilhões das emissões de CRA em 2025, seguida por 2 a 5 anos (R$12,57 bilhões).',
      data: [
        { categoria: 'de 5 a 10 anos', valor: 23045146800 },
        { categoria: 'de 2 a 5 anos', valor: 12570915724.3 },
        { categoria: 'acima de 10 anos', valor: 9569274000 },
        { categoria: 'até 2 anos', valor: 601219883 },
      ],
    },
  ],
};

export const secondaryMarket = {
  intro: [
    'O mercado secundário de CRIs e CRAs atingiu, somados, R$161,18 bilhões em volume negociado em 2025. Os CRIs superaram pela primeira vez a marca de R$100 bilhões; os CRAs bateram novo recorde, com R$57,08 bilhões. O número de transações também cresceu nos dois segmentos, com destaque para os CRIs, onde houve alta de 26,4% no número de negócios.',
    'O avanço da liquidez acompanha o crescimento do estoque e a maior pulverização da base de investidores. Ainda assim, a negociação permanece concentrada em poucos títulos: nos CRIs, as três séries mais negociadas são todas da Riza; nos CRAs, os mesmos nomes se repetem no topo do ranking de montante e de número de negócios.',
  ],
  charts: [
    {
      title: 'Negócios com CRI',
      link: 'https://metabase.uqbaronline.com/question/118-negocios-com-cri',
      description:
        'O mercado secundário de CRIs atingiu R$104,10 bilhões em 2025 e 797.683 transações, alta de 26,4% em número de negócios frente a 2024.',
      data: [
        {
          ano: '2024',
          montante_negociado: 99686225482.08951,
          numero_negocios: 630949,
        },
        {
          ano: '2025',
          montante_negociado: 104108235672.03088,
          numero_negocios: 797683,
        },
      ],
    },
    {
      title: 'Negócios com CRA',
      link: 'https://metabase.uqbaronline.com/question/704-negocios-com-cra-2024',
      description:
        'O mercado secundário de CRAs atingiu R$57,08 bilhões e 879.229 transações em 2025, novo recorde de volume.',
      data: [
        {
          ano: '2024',
          montante_negociado: 53824769517.97985,
          numero_negocios: 848991,
        },
        {
          ano: '2025',
          montante_negociado: 57077542600.91017,
          numero_negocios: 879229,
        },
      ],
    },
  ],
};

export const stock = {
  intro: [
    'O saldo devedor acumulado de CRIs e CRAs ultrapassou R$400 bilhões em dezembro de 2025: R$233,00 bilhões em CRI e R$168,58 bilhões em CRA. O CAGR do estoque de CRI entre 2021 e 2025 foi de 21,37%; o de CRA, de 27,32%. Como os prazos médios desses títulos giram entre cinco e dez anos, cada nova safra de emissões se soma às anteriores e eleva o estoque de forma acumulativa. O resultado é uma curva de crescimento que, mesmo com a desaceleração das emissões de CRI em 2025, não dá sinais de inflexão.',
  ],
  charts: [
    {
      title: 'Estoque de CRI',
      link: 'https://metabase.uqbaronline.com/question/124-estoque-de-cri',
      description:
        'O saldo devedor de CRI alcançou R$233,00 bilhões em dezembro de 2025, ante R$190,74 bilhões em 2024.',
      data: [
        { ano: '2021', saldo_devedor: 107366592312.81306 },
        { ano: '2022', saldo_devedor: 145803938180.64996 },
        { ano: '2023', saldo_devedor: 163566057690.83417 },
        { ano: '2024', saldo_devedor: 190744307106.71982 },
        { ano: '2025', saldo_devedor: 233000631055.13986 },
      ],
    },
    {
      title: 'Estoque de CRA',
      link: 'https://metabase.uqbaronline.com/question/699-estoque-de-cra-2024',
      description:
        'O saldo devedor de CRA atingiu R$168,58 bilhões em 2025, com CAGR de 27,32% entre 2021 e 2025.',
      data: [
        { ano: '2021', saldo_devedor: 64150240486.03506 },
        { ano: '2022', saldo_devedor: 97688343958.01994 },
        { ano: '2023', saldo_devedor: 120487192613.0201 },
        { ano: '2024', saldo_devedor: 135153327388.26999 },
        { ano: '2025', saldo_devedor: 168580691001.36 },
      ],
    },
  ],
};

export const rankings = {
  intro: [
    'Os rankings de CRs em 2025 refletem um mercado ainda jovem e concentrado. Por montante emitido, a Opea domina com folga, respondendo por quase metade do volume. Por número de operações, o cenário se inverte: as securitizadoras que operam via crowdfunding (RCVM 88) lideram, com o Mercado Bitcoin à frente. Três securitizadoras concentram mais de 97% das emissões. A ausência de dados de Liqi, GCB e Hurst AMFI, que não responderam à solicitação para esta edição, limita a cobertura do segmento de crowdfunding.',
    "O mercado de CRIs permanece concentrado. A Opea lidera em praticamente todos os critérios: montante emitido (49%), número de operações (34,91%) e saldo devedor (35,08%). Com a aquisição da True, a instituição combinada soma mais de 1.300 operações em circulação. No segmento de agentes fiduciários, a concentração é ainda maior: Vórtx, Oliveira Trust e Pentágono detêm mais de 97% do montante e do número de operações. A Moody's desbancou a Fitch na liderança das agências de classificação de risco.",
    "Nos CRAs, a EcoSec lidera tanto por montante emitido (49,55%) quanto por número de operações (36,69%) e saldo devedor (R$61,09 bilhões). Opea e Riza completam o pódio nos dois critérios, e as três juntas concentram mais de 85% do montante emitido. No segmento jurídico, Machado Meyer e Pinheiro Neto alternam as primeiras posições, como já ocorre há anos. A distribuição é dominada pela XP Investimentos, com 36,13% do montante. A Moody's também assumiu a liderança entre as agências de classificação de risco de CRA, ultrapassando a S&P por montante classificado, embora a S&P lidere por número de operações.",
  ],
  items: [
    {
      title: 'Ranking de Operações de CR por Montante Emitido em 2025',
      link: 'https://briefer.uqbaronline.com/workspaces/27882c7d-0508-43bb-8e53-5764136cb499/documents/1ac14121-4e67-4954-88bf-e29deaf38507/notebook/edit?sidebarCollapsed=true',
      pending: false,
      description:
        'No ranking por montante emitido de CR em 2025, a operação Sotreq (Opea) liderou com R$1,00 bilhão (21,9466%), seguida por Orígeo Comércio (Opea) com R$560 milhões e CashMe (Provincia) com R$550 milhões.',
      valueLabel: 'Montante Emitido',
      data: [
        {
          position: 1,
          name: 'Opea - Sotreq',
          value: 1000000000,
          percentage: 21.9466,
        },
        {
          position: 2,
          name: 'Opea - Orígeo Comércio',
          value: 560000000,
          percentage: 12.2901,
        },
        {
          position: 3,
          name: 'Provincia - CashMe',
          value: 550000000,
          percentage: 12.0706,
        },
        {
          position: 4,
          name: 'Opea - Vamos',
          value: 200000000,
          percentage: 4.3893,
        },
        {
          position: 5,
          name: 'Opea - Orígeo',
          value: 200000000,
          percentage: 4.3893,
        },
      ],
    },
    {
      title: 'Ranking de Securitizadoras por Montante Emitido de CR em 2025',
      link: 'https://briefer.uqbaronline.com/workspaces/27882c7d-0508-43bb-8e53-5764136cb499/documents/1ac14121-4e67-4954-88bf-e29deaf38507/notebook/edit?sidebarCollapsed=true',
      pending: false,
      description:
        'A Opea liderou o ranking de securitizadoras de CR por montante emitido em 2025, com R$2,197 bilhões (48,2269%), seguida por Mercado Bitcoin (22,9834%) e Provincia (12,0706%).',
      valueLabel: 'Montante Emitido',
      data: [
        {
          position: 1,
          name: 'Opea',
          value: 2197471374,
          percentage: 48.2269,
        },
        {
          position: 2,
          name: 'Mercado Bitcoin',
          value: 1047244917.35,
          percentage: 22.9834,
        },
        {
          position: 3,
          name: 'Provincia',
          value: 550000000,
          percentage: 12.0706,
        },
        {
          position: 4,
          name: 'TR Block',
          value: 308929933.72,
          percentage: 6.7799,
        },
        {
          position: 5,
          name: 'Vert',
          value: 209000000,
          percentage: 4.5868,
        },
      ],
    },
    {
      title: 'Ranking de Securitizadoras por Número de Operações de CR em 2025',
      link: 'https://briefer.uqbaronline.com/workspaces/27882c7d-0508-43bb-8e53-5764136cb499/documents/1ac14121-4e67-4954-88bf-e29deaf38507/notebook/edit?sidebarCollapsed=true',
      pending: false,
      description:
        'No ranking por número de operações de CR em 2025, a Mercado Bitcoin liderou com 278 operações (69,3267%), seguida por TR Block com 105 (26,1845%) e Opea com 8 (1,9950%).',
      valueLabel: 'Operações',
      data: [
        {
          position: 1,
          name: 'Mercado Bitcoin',
          value: 278,
          percentage: 69.3267,
        },
        { position: 2, name: 'TR Block', value: 105, percentage: 26.1845 },
        { position: 3, name: 'Opea', value: 8, percentage: 1.995 },
        {
          position: 4,
          name: 'CR Securitizadora',
          value: 3,
          percentage: 0.7481,
        },
        { position: 5, name: 'Vert', value: 3, percentage: 0.7481 },
      ],
    },
    {
      title: 'Ranking de Operações de CRI por Montante Emitido em 2025',
      link: 'https://uqbar.com.br/rankings/dados?market=CRI&year=2025&ranking=operation&criteria=amountissued&timeRange=yearly',
      pending: false,
      description:
        'As três maiores emissões de CRI em 2025 somaram cerca de 6,29% do volume total, lideradas pela 538ª emissão da Opea (R$1,74 bilhão).',
    },
    {
      title: 'Ranking de Securitizadoras por Montante Emitido de CRI em 2025',
      link: 'https://uqbar.com.br/rankings/dados?market=CRI&year=2025&ranking=securitizer&criteria=amount&timeRange=yearly',
      pending: false,
      description:
        'A Opea liderou com 50,2% de participação em CRI, seguida por Riza (11,8%) e VERT (9,4%).',
    },
    {
      title:
        'Ranking de Securitizadoras por Número de Operações de CRI em 2025',
      link: 'https://uqbar.com.br/rankings/dados?market=CRI&year=2025&ranking=securitizer&criteria=operations&timeRange=yearly',
      pending: false,
      description:
        'Opea liderou em número de operações de CRI com 146 emissões, seguida por Província (46) e Riza (41).',
    },
    {
      title: 'Ranking de Advogados por Montante Emitido de CRI em 2025',
      link: 'https://uqbar.com.br/rankings/dados?market=CRI&year=2025&ranking=legaladvisor&criteria=amount&timeRange=yearly',
      pending: false,
      description:
        'Mattos Filho liderou com R$7,45 bilhões, seguido por Lobo & De Rizzo e Tauil e Chequer.',
    },
    {
      title: 'Ranking de Advogados por Número de Operações de CRI em 2025',
      link: 'https://uqbar.com.br/rankings/dados?market=CRI&year=2025&ranking=legaladvisor&criteria=operations&timeRange=yearly',
      pending: false,
      description:
        'NFA liderou com 63 operações, seguido por PMK (43) e Cescon Barrieu (24).',
    },
    {
      title:
        'Ranking de Agências de Classificação de Risco por Montante Classificado de CRI em 2025',
      link: 'https://uqbar.com.br/rankings/dados?market=CRI&year=2025&ranking=agencyrating&criteria=amount&timeRange=yearly',
      pending: false,
      description:
        "Moody's assumiu a liderança com R$9,01 bilhões classificados, seguida por S&P e Fitch.",
    },
    {
      title:
        'Ranking de Agências de Classificação de Risco por Número de CRI Classificados em 2025',
      link: 'https://uqbar.com.br/rankings/dados?market=CRI&year=2025&ranking=agencyrating&criteria=operations&timeRange=yearly',
      pending: false,
      description:
        "Moody's liderou com 53 operações classificadas (54,08%), seguida por S&P com 30.",
    },
    {
      title:
        'Ranking de Agentes Fiduciários por Montante Emitido de CRI em 2025',
      link: 'https://uqbar.com.br/rankings/dados?market=CRI&year=2025&ranking=fiduciaryagent&criteria=amount&timeRange=yearly',
      pending: false,
      description:
        'Vórtx liderou com R$27,95 bilhões, seguida por Oliveira Trust e Pentágono.',
    },
    {
      title:
        'Ranking de Agentes Fiduciários por Número de Operações de CRI em 2025',
      link: 'https://uqbar.com.br/rankings/dados?market=CRI&year=2025&ranking=fiduciaryagent&criteria=operations&timeRange=yearly',
      pending: false,
      description:
        'Vórtx liderou com 236 operações de CRI, seguida por Oliveira Trust com 133.',
    },
    {
      title:
        'Ranking de Líderes de Distribuição por Montante Emitido de CRI em 2025',
      link: 'https://uqbar.com.br/rankings/dados?market=CRI&year=2025&ranking=distributor&criteria=amount&timeRange=yearly',
      pending: false,
      description:
        'Banco Itaú BBA liderou com R$8,52 bilhões, seguido por XP Investimentos e BTG Pactual Asset Management.',
    },
    {
      title: 'Ranking de Líderes de Distribuição por Número de CRI em 2025',
      link: 'https://uqbar.com.br/rankings/dados?market=CRI&year=2025&ranking=distributor&criteria=titlesnumber&timeRange=yearly',
      pending: false,
      description:
        'Opea liderou com 54 títulos distribuídos, seguida por Província e Canal.',
    },
    {
      title: 'Ranking de Servicers por Montante Emitido de CRI em 2025',
      link: 'https://uqbar.com.br/rankings/dados?market=CRI&year=2025&ranking=servicer&criteria=amount&timeRange=yearly',
      pending: false,
      description:
        'Neo Service liderou com R$4,97 bilhões, seguida por E-Arke e Monitor Imobiliário.',
    },
    {
      title: 'Ranking de Servicers por Número de Operações de CRI em 2025',
      link: 'https://uqbar.com.br/rankings/dados?market=CRI&year=2025&ranking=servicer&criteria=operations&timeRange=yearly',
      pending: false,
      description:
        'Neo Service liderou com 101 operações, seguido por Monitor Imobiliário e E-Arke.',
    },
    {
      title: 'Ranking de CRI por Montante Negociado em 2025 (+180 dias)',
      link: 'https://www.uqbar.com.br/rankings/dados?market=CRI&year=2025&ranking=securitycri&criteria=amountnegotiated&timeRange=yearly',
      pending: false,
      description:
        'As três primeiras séries mais negociadas de CRI em 2025 somaram R$4,98 bilhões.',
    },
    {
      title: 'Ranking de CRI por Número de Negócios em 2025 (+180 dias)',
      link: 'https://uqbar.com.br/rankings/dados?market=CRI&year=2025&ranking=securitycri&criteria=tradesnumber&timeRange=yearly',
      pending: false,
      description:
        'O CRI VERT DASA liderou em número de negócios com 16.736 negociações.',
    },
    {
      title: 'Ranking de Securitizadoras por Saldo Devedor dos CRI',
      link: 'https://uqbar.com.br/rankings/dados?market=CRI&year=2025&ranking=securitizer&criteria=debitbalance&timeRange=yearly',
      pending: false,
      description:
        'Opea liderou com R$81,74 bilhões de saldo devedor, seguida por True e Riza.',
    },
    {
      title:
        'Ranking de Securitizadoras por Número de Operações de CRI em Circulação',
      link: 'https://uqbar.com.br/rankings/dados?market=CRI&year=2025&ranking=securitizer&criteria=operations&timeRange=consolidated',
      pending: false,
      description:
        'Opea liderou com 771 operações em circulação, seguida por True e Riza.',
    },
    {
      title: 'Ranking de Agentes Fiduciários por Saldo Devedor de CRI',
      link: 'https://uqbar.com.br/rankings/dados?market=CRI&year=2025&ranking=fiduciaryagent&criteria=debitbalance&timeRange=yearly',
      pending: false,
      description:
        'Vórtx liderou com R$83,55 bilhões sob custódia, seguida por Oliveira Trust e Pentágono.',
    },
    {
      title:
        'Ranking de Agentes Fiduciários por Número de Operações de CRI em Circulação',
      link: 'https://uqbar.com.br/rankings/dados?market=CRI&year=2025&ranking=fiduciaryagent&criteria=operations&timeRange=consolidated',
      pending: false,
      description:
        'As três principais instituições concentram a maior parte das operações de CRI em circulação.',
    },
    {
      title: 'Ranking de Operações de CRA por Montante Emitido',
      link: 'https://uqbar.com.br/rankings/dados?market=CRA&year=2025&ranking=operation&criteria=amountissued&timeRange=yearly',
      pending: false,
      description:
        'As três maiores emissões de CRA somaram quase 20% do total captado em 2025.',
    },
    {
      title:
        'Ranking de Securitizadoras do Agronegócio por Montante Emitido de CRA em 2025',
      link: 'https://uqbar.com.br/rankings/dados?market=CRA&year=2025&ranking=securitizer&criteria=amount&timeRange=yearly',
      pending: false,
      description:
        'EcoSec liderou com R$22,56 bilhões, seguida por Opea e Riza.',
    },
    {
      title:
        'Ranking de Securitizadoras do Agronegócio por Número de Operações de CRA em 2025',
      link: 'https://uqbar.com.br/rankings/dados?market=CRA&year=2025&ranking=securitizer&criteria=operations&timeRange=yearly',
      pending: false,
      description:
        'EcoSec liderou com 51 operações, seguida por Opea (36) e Riza (21).',
    },
    {
      title:
        'Ranking de Agentes Fiduciários por Montante Emitido de CRA em 2025',
      link: 'https://uqbar.com.br/rankings/dados?market=CRA&year=2025&ranking=fiduciaryagent&criteria=amount&timeRange=yearly',
      pending: false,
      description:
        'Vórtx liderou com R$26,91 bilhões, seguida por Oliveira Trust e Pentágono.',
    },
    {
      title:
        'Ranking de Agentes Fiduciários por Número de Operações de CRA em 2025',
      link: 'https://uqbar.com.br/rankings/dados?market=CRA&year=2025&ranking=fiduciaryagent&criteria=operations&timeRange=yearly',
      pending: false,
      description:
        'Vórtx liderou com 84 operações, seguida por Oliveira Trust com 51.',
    },
    {
      title:
        'Ranking de Assessores Jurídicos por Montante Emitido de CRA em 2025',
      link: 'https://uqbar.com.br/rankings/dados?market=CRA&year=2025&ranking=legaladvisor&criteria=amount&timeRange=yearly',
      pending: false,
      description:
        'Machado Meyer liderou com R$14,08 bilhões, seguido por Pinheiro Neto e Lefosse.',
    },
    {
      title:
        'Ranking de Assessores Jurídicos por Número de Operações de CRA em 2025',
      link: 'https://uqbar.com.br/rankings/dados?market=CRA&year=2025&ranking=legaladvisor&criteria=operations&timeRange=yearly',
      pending: false,
      description:
        'Pinheiro Neto liderou com 33 operações, seguido por VBSO e Machado Meyer.',
    },
    {
      title:
        'Ranking de Líderes de Distribuição por Montante Emitido de CRA em 2025',
      link: 'https://uqbar.com.br/rankings/dados?market=CRA&year=2025&ranking=distributor&criteria=amount&timeRange=yearly',
      pending: false,
      description:
        'XP Investimentos liderou com R$16,40 bilhões em distribuição de CRA.',
    },
    {
      title: 'Ranking de Líderes de Distribuição por Número de CRA em 2025',
      link: 'https://uqbar.com.br/rankings/dados?market=CRA&year=2025&ranking=distributor&criteria=titlesnumber&timeRange=yearly',
      pending: false,
      description:
        'XP Investimentos liderou com 28 títulos, seguida por EcoSec e Banco Itaú.',
    },
    {
      title:
        'Ranking de Agências de Classificação de Risco por Montante Classificado de CRA',
      link: 'https://uqbar.com.br/rankings/dados?market=CRA&year=2025&ranking=agencyrating&criteria=amount&timeRange=yearly',
      pending: false,
      description:
        "Moody's liderou com R$12,95 bilhões, seguida por S&P e Fitch.",
    },
    {
      title:
        'Ranking de Agências de Classificação de Risco por Número de CRA Classificados',
      link: 'https://uqbar.com.br/rankings/dados?market=CRA&year=2025&ranking=agencyrating&criteria=operations&timeRange=yearly',
      pending: false,
      description:
        "S&P liderou com 42 operações classificadas, seguida por Moody's e Fitch.",
    },
    {
      title: 'Ranking de Servicers por Montante Emitido de CRA em 2025',
      link: 'https://uqbar.com.br/rankings/dados?market=CRA&year=2025&ranking=servicer&criteria=amount&timeRange=yearly',
      pending: false,
      description:
        'ACE liderou com 54,41% do montante emitido por servicers de CRA.',
    },
    {
      title: 'Ranking de Servicers por Número de Operações de CRA em 2025',
      link: 'https://uqbar.com.br/rankings/dados?market=CRA&year=2025&ranking=servicer&criteria=operations&timeRange=yearly',
      pending: false,
      description:
        'ACE liderou com 12 operações (75%), seguida por Ceres e Control.',
    },
    {
      title: 'Ranking de CRA por Montante Negociado (+180 dias) em 2025',
      link: 'https://uqbar.com.br/rankings/dados?market=CRA&year=2025&ranking=securitycra&criteria=amountnegotiated&timeRange=yearly',
      pending: false,
      description:
        'Riza São Martinho liderou com R$2,06 bilhões negociados no mercado secundário.',
    },
    {
      title: 'Ranking de CRA por Número de Negócios (+180 dias) em 2025',
      link: 'https://uqbar.com.br/rankings/dados?market=CRA&year=2025&ranking=securitycra&criteria=tradesnumber&timeRange=yearly',
      pending: false,
      description:
        'CRA Opea Engelhart IV liderou com 32.485 negociações em 2025.',
    },
    {
      title: 'Ranking de Securitizadoras por Saldo Devedor de CRA',
      link: 'https://uqbar.com.br/rankings/dados?market=CRA&year=2025&ranking=securitizer&criteria=debitbalance&timeRange=yearly',
      pending: false,
      description:
        'EcoSec lidera o estoque de CRA com R$61,09 bilhões, seguida por Riza e Opea.',
    },
    {
      title:
        'Ranking de Securitizadoras por Número de Operações de CRA em Circulação',
      link: 'https://uqbar.com.br/rankings/dados?market=CRA&year=2025&ranking=securitizer&criteria=operations&timeRange=consolidated',
      pending: false,
      description:
        'EcoSec lidera com 413 operações em circulação, seguida por Riza e Opea.',
    },
    {
      title: 'Ranking de Agentes Fiduciários por Saldo Devedor de CRA',
      link: 'https://uqbar.com.br/rankings/dados?market=CRA&year=2025&ranking=fiduciaryagent&criteria=debitbalance&timeRange=yearly',
      pending: false,
      description:
        'Oliveira Trust lidera com R$74,70 bilhões, seguida por Vórtx e Pentágono.',
    },
    {
      title:
        'Ranking de Agentes Fiduciários por Número de Operações de CRA em Circulação',
      link: 'https://uqbar.com.br/rankings/dados?market=CRA&year=2025&ranking=fiduciaryagent&criteria=operations&timeRange=consolidated',
      pending: false,
      description:
        'Oliveira Trust lidera com 481 operações, seguida por Vórtx e Pentágono.',
    },
  ],
};
